"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledReportPeriodUnits = exports.ReportGeneratorSetupInputEnum = void 0;
/** These types are to do with the setting up of a report schedule */
var ReportGeneratorSetupInputEnum;
(function (ReportGeneratorSetupInputEnum) {
    ReportGeneratorSetupInputEnum["GROUP"] = "group";
    ReportGeneratorSetupInputEnum["VALIDBUSINESSOBJECT"] = "ValidBusinessObject";
    ReportGeneratorSetupInputEnum["STRING"] = "string";
    ReportGeneratorSetupInputEnum["NUMBER"] = "number";
})(ReportGeneratorSetupInputEnum || (exports.ReportGeneratorSetupInputEnum = ReportGeneratorSetupInputEnum = {}));
var ScheduledReportPeriodUnits;
(function (ScheduledReportPeriodUnits) {
    ScheduledReportPeriodUnits["HOUR"] = "hour";
    ScheduledReportPeriodUnits["DAY"] = "day";
    ScheduledReportPeriodUnits["WEEK"] = "week";
    //MONTH = 'month',
})(ScheduledReportPeriodUnits || (exports.ScheduledReportPeriodUnits = ScheduledReportPeriodUnits = {}));
